<template>
  <div class="tab-label-container">
    <span class="d-block mr-2">{{ name }}</span>
    <a-badge
      v-if="is_default"
      count="Default"
      :number-style="{
        backgroundColor: '#fff',
        color: '#999',
        boxShadow: '0 0 0 1px #d9d9d9 inset',
      }"
    />
    <PingDot :show="error_validate" />
  </div>
</template>

<script>
import PingDot from './PingDot.vue'

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    is_default: {
      type: Boolean,
      default: false,
    },
    error_validate: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PingDot,
  },
}
</script>

<style lang="scss">
.tab-label-container {
  display: flex;
  align-items: center;
  position: relative;
}
</style>
